import { Options } from '@angular-slider/ngx-slider';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { Busca, Orcamento, Paginacao } from 'src/app/model';
import { Circuito, FiltroAdicional, FiltroCircuito } from 'src/app/model/turismo/circuito.model';
import { CircuitoService } from 'src/app/services/turismo/circuito.service';

@Component({
  selector: 'app-lista-circuito',
  standalone: false,
  templateUrl: './lista-circuito.component.html',
  styleUrl: './lista-circuito.component.scss'
})
export class ListaCircuitoComponent implements OnInit {
  @Input() busca: Busca;
  @Input() Orcamento: Orcamento;
  @Input() events: Observable<void>;

  @Output() removeu = new EventEmitter<any>();

  private eventsSubscription: Subscription;

  PaisesFiltro: string[] = [];
  CidadesFiltro: string[] = [];
  pesquisaCidade: string;
  pesquisaPais: string;
  filterTextCidade: string;
  filterTextPaises: string
  originalItemsCidades = [];
  originalItemsPais = [];
  filtrou: any = false;
  Cidades = [];
  FiltrosAdicionais: FiltroAdicional = new FiltroAdicional();
  FiltroCircuito: FiltroCircuito = new FiltroCircuito();

  adicionando: boolean = false;

  // CIRCUITOS
  Fornecedores: string[] = ["ST"];
  Temporadas: string[] = [];
  Temporada: string;

  MensagensErro: any;
  MensagensSucesso: any;

  buscasAtivas = [];
  buscando = false;
  rebusca = false;
  cidades = [];
  totalpax = 0;
  Voos: any[] = [];
  OpcoesDuracaoTrechos: any[];

  Guid: string = '';
  Circuitos = [];
  itemReserva: any;

  carregando = true;

  OrcamentoReserva: Orcamento = new Orcamento();
  paginacao: Paginacao = new Paginacao();

  OpcoesValor: Options = {
    floor: 0,
    ceil: 99999,
    getPointerColor: (value: number): string => {
      return "var(--primaria)";
    },
    getSelectionBarColor: (value: number): string => {
      return "var(--primaria)";
    },
  };

  timer = null;
  buscarDebounce() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.refazerBusca(this.busca), 600);
  }

  constructor(
    private circuitoService: CircuitoService,
    private modalService: NgbModal,
    public _router: Router,
    public route: ActivatedRoute
  ) { }

  ngOnInit() { 
    this.buscar();
    this.eventsSubscription = this.events.subscribe((busca) => this.refazerBusca(busca));
  }

  buscar(buscarCircuito = null) {
    if (buscarCircuito == null) {
      buscarCircuito = this.busca.getBuscaCircuito();
    }  

    if (this.adicionando) {
      this.FiltroCircuito.Fornecedores = ["ST"];
    }

    buscarCircuito.FiltroCircuito = this.FiltroCircuito;

    if (!this.buscando) {
      this.Circuitos = [];
    }

    this.MensagensErro = '';
    this.buscando = true;
    this.circuitoService
      .buscarCircuitos(buscarCircuito, this.paginacao.NumeroPagina)
      .subscribe(
        dados => {
          this.buscasAtivas = JSON.parse(dados.MetaData.BuscasAtivas);
          this.busca.guid = dados.MetaData.Guid;
          buscarCircuito.Guid = dados.MetaData.Guid;
          this.paginacao.NumeroPagina = dados.MetaData.NumeroPagina;
          this.paginacao.TotalItens = dados.MetaData.TotalItens;
          this.paginacao.ItensPorPagina = dados.MetaData.itensPorPagina;
          this.paginacao.TotalPaginas = dados.MetaData.TotalPaginas;

          const meta = JSON.parse(dados.MetaData.MetaDados);

          if (meta != null) {
            if (!(this.FiltroCircuito.ValorMinimo > 0)) {
              this.FiltroCircuito.ValorMinimo = meta.ValorMinimo;
              this.FiltroCircuito.ValorMaximo = meta.ValorMaximo;
            }
            this.PaisesFiltro = meta.Paises;
            this.CidadesFiltro = meta.Cidades;
            this.originalItemsCidades = this.CidadesFiltro;
            this.originalItemsPais = this.PaisesFiltro;
            this.Fornecedores = meta.Fornecedores;

            this.OpcoesValor.floor = meta.ValorMinimo;
            this.OpcoesValor.ceil = meta.ValorMaximo;

            if (!this.filtrou) {
              this.FiltrosAdicionais.Rios = meta.FiltrosAdicionais.Rios;
              this.FiltrosAdicionais.Barcos = meta.FiltrosAdicionais.Barcos;
            }
          }
          else {
            this.PaisesFiltro = [];
            this.CidadesFiltro = [];
            this.Fornecedores = [];

            this.FiltroCircuito.ValorMinimo = 0;
            this.FiltroCircuito.ValorMaximo = 0;
            this.OpcoesValor.floor = 0;
            this.OpcoesValor.ceil = 99999;
          }

          this.Circuitos = dados.Items.map(x => {
            if (x.Fornecedor == "SRL") {
              x.CategoriasCircuitos = JSON.parse(x.Extra);
              x.CategoriaCodigo = "";
            }
            x.Id = x.Id * -1;
            return x;
          });

          window.sessionStorage.setItem('busca', JSON.stringify(this.busca));

          if (this.buscasAtivas.length > 0 && (window.location.href.split('/').indexOf("circuito") !== -1 || window.location.href.split('/').indexOf('adicionar') !== -1)) {
            setTimeout(() => {
              this.buscar(buscarCircuito);
            }, 3000);
          } else {
            this.buscando = false;
          }
        },
        erro => {
          console.log(erro);
          this.MensagensErro = erro.error.mensagem;
          this.buscando = false;
        }
      );
  }

  buscarPagina(pagina) {
    this.carregando = true;
    this.paginacao.NumeroPagina = pagina;
    this.buscar();
  }

  refazerBusca(busca) {
    if (this.aba() == 'circuito') {
      this.busca = busca;
      window.scroll(0, 0);
      this.paginacao.NumeroPagina = 1;
      this.buscando = true;
      this.buscar(busca);
    }
  }

  aba() {
    if (this.route.snapshot.params.tipo != null) {
      return this.route.snapshot.params.tipo;
    } else {
      let x = this._router.url.split("/");
      return x[x.length - 1];
    }
    return "";
  }

  filterItemCidades(event) {
    if (!event) {
      this.CidadesFiltro = this.originalItemsCidades;
    }
    if (typeof event === 'string') {
      this.CidadesFiltro = this.originalItemsCidades.filter(a => a.toLowerCase().startsWith(event.toLowerCase()));
    }
  }

  filterItemPaises(event) {
    if (!event) {
      this.PaisesFiltro = this.originalItemsPais;
    }
    if (typeof event === 'string') {
      this.PaisesFiltro = this.originalItemsPais.filter(a => a.toLowerCase().startsWith(event.toLowerCase()));
    }
  }

  valorCategoriaSelecionado: string = " ";

  transformString(item: String): String {
    if (item != undefined) {
      const arr = item.toLowerCase().split(",");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }
      return arr.join(", ");
    }
  }

  fornecedorSelecionado(fornecedor) {
    return this.FiltroCircuito.Fornecedores.indexOf(fornecedor) >= 0;
  }

  selecionarFornecedor(fornecedor) {
    if (this.fornecedorSelecionado(fornecedor)) {
      this.FiltroCircuito.Fornecedores = this.FiltroCircuito.Fornecedores.filter(x => x != fornecedor);
    } else {
      this.FiltroCircuito.Fornecedores.push(fornecedor);
    }
  }

  circuito: Circuito;
  abrirModalPreOrcamento(event, content) {
    this.circuito = event;
    this.modalService.open(content, { size: 'xl', backdrop: 'static', centered: true });
  }

  selecionarCidades(cidade) {
    typeof cidade === 'string' ? '' : cidade = cidade[0];

    if (this.FiltroCircuito.Cidades.indexOf(cidade) >= 0)
      this.FiltroCircuito.Cidades = this.FiltroCircuito.Cidades.filter(x => x != cidade);
    else
      this.FiltroCircuito.Cidades.push(cidade);
  }

  selecionarPaises(pais) {
    typeof pais === 'string' ? '' : pais = pais[0];

    if (this.FiltroCircuito.Paises.indexOf(pais) >= 0)
      this.FiltroCircuito.Paises = this.FiltroCircuito.Paises.filter(x => x != pais);
    else
      this.FiltroCircuito.Paises.push(pais);
  }
}